export     const labels = {
    MedSalePrice: "Median Home Prices",
    SoldCount: "Number of Sales", 
    SoldAvgDOM:"Days on Market",
    AvgSalePricePerSqft:"Price per Square Foot",
    SaleVolume:"Sales Volume",
    AvgSaleOverListPrice:"SP/LP" ,
    ActiveCount:"ActiveCount"    
    ,ContingentCount:"ContingentCount"
    ,PendingCount:"PendingCount"
    ,ActiveAvgDOM:"ActiveAvgDOM"
    ,ActiveMedDOM:"ActiveMedDOM"
    ,InventoryCount:"InventoryCount"
    ,InventoryAvgDOM:"InventoryAvgDOM"
    ,InventoryAvgListPrice:"InventoryAvgListPrice"
    ,NewListingsCount:"NewListingsCount"
    ,NewListingsAvgListPrice:"NewListingsAvgListPrice"
    ,UnderContractCount:"UnderContractCount"
    ,UnderContractAvgDOM:"UnderContractAvgDOM"
    ,UnderContractAvgListPrice:"UnderContractAvgListPrice"
    ,ActiveAvgListPrice:"ActiveAvgListPrice"
    ,ActiveAvgListPricePerSqft:"ActiveAvgListPricePerSqft"
    ,ActiveAvgOriginalPrice:"ActiveAvgOriginalPrice"
    ,ActiveMedListPrice:"ActiveMedListPrice"
    ,ActiveMedListPricePerSqft:"ActiveMedListPricePerSqft"
    
    ,SoldMedDOM:"SoldMedDOM"
    ,SoldAvgListPrice:"SoldAvgListPrice"
    ,SoldMedListPrice:"SoldMedListPrice" 
    ,AvgSalePrice:"AvgSalePrice"     
    ,AvgSaleOverOriginalPrice:"AvgSaleOverOriginalPrice"  
    ,MedSalePricePerSqft:"MedSalePricePerSqft"

}

export     const legendlabels = {
    MedSalePrice: "Med",
    SoldCount: "Sales", 
    SoldAvgDOM:"DOM",
    AvgSalePricePerSqft:"$/SF",
    SaleVolume:"Sales Volume",    
    AvgSaleOverListPrice:"SP/LP",
    ActiveCount:"ActiveCount"
    ,ContingentCount:"ContingentCount"
    ,PendingCount:"PendingCount"
    ,ActiveAvgDOM:"ActiveAvgDOM"
    ,ActiveMedDOM:"ActiveMedDOM"
    ,InventoryCount:"InventoryCount"
    ,InventoryAvgDOM:"InventoryAvgDOM"
    ,InventoryAvgListPrice:"InventoryAvgListPrice"
    ,NewListingsCount:"NewListingsCount"
    ,NewListingsAvgListPrice:"NewListingsAvgListPrice"
    ,UnderContractCount:"UnderContractCount"
    ,UnderContractAvgDOM:"UnderContractAvgDOM"
    ,UnderContractAvgListPrice:"UnderContractAvgListPrice"
    ,ActiveAvgListPrice:"ActiveAvgListPrice"
    ,ActiveAvgListPricePerSqft:"ActiveAvgListPricePerSqft"
    ,ActiveAvgOriginalPrice:"ActiveAvgOriginalPrice"
    ,ActiveMedListPrice:"ActiveMedListPrice"
    ,ActiveMedListPricePerSqft:"ActiveMedListPricePerSqft"
 
    ,SoldMedDOM:"SoldMedDOM"
    ,SoldAvgListPrice:"SoldAvgListPrice"
    ,SoldMedListPrice:"SoldMedListPrice" 
    ,AvgSalePrice:"AvgSalePrice"   
    ,AvgSaleOverOriginalPrice:"AvgSaleOverOriginalPrice"
    ,MedSalePricePerSqft:"MedSalePricePerSqft"
}


// WEBPACK FOOTER //
// ./src/labels.js